(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    const lcdUpdateMobileMenuOffset = () => {
if (!window.matchMedia('(max-width:749px)').matches) return;
document.querySelectorAll('header-drawer:has(.lcd-mobile-menu)').forEach(drawer => {
const header = drawer.closest('#header-component');
drawer.style.setProperty('--lcd-mobile-menu-top', (header ? Math.max(0,header.getBoundingClientRect().top) : 0) + 'px');
drawer.dataset.lcdMobileNavReady='true';
});
};
document.addEventListener('click', event => {if(event.target.closest('.header__drawer .header__icon--summary')) lcdUpdateMobileMenuOffset();},true);
document.addEventListener('pointerdown',event=>{if(event.target.closest('.header__drawer .header__icon--summary'))lcdUpdateMobileMenuOffset();},true);
window.addEventListener('resize',lcdUpdateMobileMenuOffset);
lcdUpdateMobileMenuOffset();
  } catch(e) { console.error(e); }
})();

})();
